(function (angular, app) {
    'use strict';

    app.directive('spProduct', ['Util', function (Util) {
        return {
            restrict: 'E',
            scope: {
                size: '@',
                text: '@',
                hideCart: '@',
                hideSales: '@',
                product: '=',
                showItemDescription: '<',
                boostProductTags: '<?',
                openProduct: '&?',
                source: '=?',
                itemPosition: '=?',
                itemsCount: '=?',
                componentType: '=?',
                componentPosition: '=?',
                carouselName: '=?',
                specialId: '=?',
                homePageCarouselType: '@?'
            },
            controller: ['$scope', '$rootScope', 'Config','User', 'Cart', 'Util', function ($scope, $rootScope, Config, User, Cart, Util) {
                var _listeners = [];
                function init(){
                    $scope.productSpecials = Util.filterProductSpecials($scope.product.isCaseMode ? $scope.product.branch.case : $scope.product.branch); 
                    $scope.specialToShow = Util.getSpecialToShow($scope.productSpecials, $scope.product);
                    $scope.isShowTprDisplay = false;
                    if (Config.isUs &&
                        Config.retailer.settings.isNewPromotionDesignEnabled === 'true' &&
                        $scope.product &&
                        $scope.specialToShow &&
                        $scope.specialToShow.isTPRPromotion
                    ) {
                        $scope.isShowTprDisplay = true;
                    }
                }
                init();
                $scope.hasClubSpecial = Util.productHasClubSpecial($scope.product.branch);
                $scope.getLine = getLine;
                $scope.isHideAddButton = Util.isHideAddButton($scope.product);

                var _isRetailerPremiumReplacementsEnabled = Config.retailer.settings.enablePersonalReplacement;
                
                function getLine() {
                    return Util.getProductCartLine($scope.product, $scope.product.isCaseMode);
                }

                $scope.showReplacementLabel = false;
                
                if (_isRetailerPremiumReplacementsEnabled) {
                    $rootScope.$on('cart.update.complete', function() {
                        Util.setReplacement($scope)
                    })
                    $rootScope.$on('loginForAnalyticServiceProvider', function() {
                        Util.setReplacement($scope)
                    })
                }
                _listeners.push($scope.$watch('product.isCaseMode', function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                      init();
                    }
                }));
                Util.destroyListeners($scope, _listeners);
            }],
            templateUrl: 'template/directives/sp-product/index.html',
            link: function ($scope, $element, $attrs) {
                $element.attr('itemprop', 'itemListElement');
                var host = $element[0];
                var addToCartBtn;

                function getAddToCartButton() {
                    if (!addToCartBtn || !host.contains(addToCartBtn)) {
                        addToCartBtn = host.querySelector('button.add-to-cart.aria-show-focus');
                    }
                    return addToCartBtn;
                }

                var pointerDown = false;
                var dragStarted = false;
                var startX = 0;
                var startY = 0;
                var DRAG_THRESHOLD = 5;

                function clearHoverState() {
                    $element.removeClass('hover-mode');
                    setAddToCartExposed(false);
                }

                function forceHideActions() {
                    clearHoverState();
                    $element.addClass('force-hide-actions');
                    var focused = document.activeElement;
                    if (focused && host.contains(focused) && typeof focused.blur === 'function') {
                        focused.blur();
                    }
                }

                function isPointerOverHost(event) {
                    if (!event || event.clientX == null || event.clientY == null) {
                        return false;
                    }
                    var el = document.elementFromPoint(event.clientX, event.clientY);
                    return !!(el && host.contains(el));
                }

                function cleanupPointerListeners() {
                    document.removeEventListener('pointermove', onPointerMove);
                    document.removeEventListener('pointerup', onPointerUp);
                    document.removeEventListener('pointercancel', onPointerUp);
                }

                function finishPointerInteraction(event) {
                    cleanupPointerListeners();
                    pointerDown = false;
                    // Drag, or click ended with pointer not on the tile (sticky :hover case).
                    if (dragStarted || !isPointerOverHost(event)) {
                        forceHideActions();
                    }
                    dragStarted = false;
                }

                function onPointerMove(event) {
                    if (!pointerDown) {
                        return;
                    }
                    if (Math.abs(event.clientX - startX) > DRAG_THRESHOLD ||
                        Math.abs(event.clientY - startY) > DRAG_THRESHOLD) {
                        dragStarted = true;
                        forceHideActions();
                    }
                }

                function onPointerUp(event) {
                    finishPointerInteraction(event);
                }

                function onPointerDown(event) {
                    if (event.button !== 0) {
                        return;
                    }
                    pointerDown = true;
                    dragStarted = false;
                    startX = event.clientX;
                    startY = event.clientY;
                    // Real intentional interaction — allow hover UI again until drag moves away.
                    $element.removeClass('force-hide-actions');
                    document.addEventListener('pointermove', onPointerMove);
                    document.addEventListener('pointerup', onPointerUp);
                    document.addEventListener('pointercancel', onPointerUp);
                }

                function onMouseEnter() {
                    // Real mouse enter clears the sticky-hover override.
                    $element.removeClass('force-hide-actions');
                }

                function setAddToCartExposed(exposed) {
                    var btn = getAddToCartButton();
                    if (!btn) {
                        return;
                    }
                    if (exposed) {
                        btn.removeAttribute('aria-hidden');
                    } else {
                        btn.setAttribute('aria-hidden', 'true');
                    }
                }

                function onFocusIn() {
                    // Keyboard / restored focus should show actions again.
                    $element.removeClass('force-hide-actions');
                    $element.addClass('hover-mode');
                    setAddToCartExposed(true);
                }

                function onFocusOut(event) {
                    var related = event.relatedTarget;
                    if (related && host.contains(related)) {
                        return;
                    }
                    clearHoverState();
                }

                function onMouseOut(event) {
                    var related = event.relatedTarget;
                    if (related && host.contains(related)) {
                        return;
                    }
                    if (!host.matches(':focus-within')) {
                        clearHoverState();
                    }
                }

                $element.attr('itemscope', '');
                $element.attr('itemtype', 'https://schema.org/ListItem');
                $element.attr('role', 'none');

                host.addEventListener('focusin', onFocusIn);
                host.addEventListener('focusout', onFocusOut);
                host.addEventListener('mouseout', onMouseOut);
                host.addEventListener('pointerdown', onPointerDown);
                host.addEventListener('mouseenter', onMouseEnter);

                $scope.$on('$destroy', function () {
                    cleanupPointerListeners();
                    host.removeEventListener('focusin', onFocusIn);
                    host.removeEventListener('focusout', onFocusOut);
                    host.removeEventListener('mouseout', onMouseOut);
                    host.removeEventListener('pointerdown', onPointerDown);
                    host.removeEventListener('mouseenter', onMouseEnter);
                });
            }
        };
    }]);
})(angular, app);